import hasControlChars from './hasControlChars';

/**
 * Returns `value` only if it is a same-origin, path-only destination
 * (single leading slash); otherwise returns `fallback`. Rejects absolute URLs,
 * protocol-relative "//host", backslash variants, control characters and any
 * scheme such as "javascript:".
 * @param {string | null | undefined} value
 * @param {string} fallback
 * @returns {string}
 */
export default function getSafeRedirectPath(value, fallback = '/') {
  if (typeof value !== 'string') return fallback;

  const isPathOnly = /^\/(?![/\\])/.test(value);
  if (!isPathOnly || hasControlChars(value)) return fallback;

  try {
    const { origin } = window.location;
    return new URL(value, origin).origin === origin ? value : fallback;
  } catch (_) {
    return fallback;
  }
}
